var map = {
	"./en-US-messages.json": 644,
	"./es-MX-messages.json": 645,
	"./ja-JP-messages.json": 646,
	"./ko-KR-messages.json": 647,
	"./pt-BR-messages.json": 648,
	"./zh-TW-messages.json": 649
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 643;